module.exports = __webpack_public_path__ + "assets/img/24-m.450442a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/24-m.jpg
// module id = nMmY
// module chunks = 0